import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import PropTypes from 'prop-types'
import isFunction from 'lodash/isFunction'

class ACL extends Component {
  isAllowed = () => {
    const { userStore, roles, positions, hideForAdmin, staticData } = this.props
    const { employeePositionId } = userStore.user.currentPosition

    const isAdmin = userStore.user.permissions.find(permission => {
      return permission.name.toLowerCase() === 'admin'
    })

    if (isAdmin && hideForAdmin) return false
    if (isAdmin) return true

    const isAllowedRole = roles.some(role => {
      return userStore.user.permissions.find(permission => {
        return permission.name.toLowerCase() === role.toLowerCase()
      })
    })

    let isAllowedPosition = false

    if (employeePositionId && positions) {
      const employeePosition =
        staticData.names.employeePositions[employeePositionId]
      isAllowedPosition = positions.includes(employeePosition)
    }

    return isAllowedRole || isAllowedPosition
  }

  render() {
    const { action, alternative, inline, children } = this.props

    const isRenderProp = isFunction(children)

    if (!this.isAllowed() && !isRenderProp) return alternative || null

    let className = ''
    if (inline) className += ' inline'
    if (action) className += ' action'

    const renderChildren = isRenderProp ? children(this.isAllowed()) : children

    return <div className={className}>{renderChildren}</div>
  }
}

ACL.defaultProps = {
  alternative: null,
  roles: [],
  hideForAdmin: false
}

ACL.propTypes = {
  action: PropTypes.bool,
  alternative: PropTypes.node,
  children: PropTypes.any,
  roles: PropTypes.array,
  positions: PropTypes.array,
  inline: PropTypes.bool,
  hideForAdmin: PropTypes.bool,
  userStore: PropTypes.object,
  staticData: PropTypes.object
}

export default inject('userStore', 'staticData')(observer(ACL))
